import React, { useMemo } from 'react'
import { HelmetProvider, Helmet } from 'react-helmet-async'
import {
  Theme,
  ThemeProvider,
  StyledEngineProvider,
  ThemeOptions,
  createTheme,
} from '@mui/material/styles'
import '@mui/styles'

import { createRobotenTheme, RobotenTheme } from '../../theme'

declare module '@mui/styles' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

export interface IHost {
  children?: React.ReactNode
  theme?: ThemeOptions
  mergeWith?: 'MUI' | 'Roboten'
}

export const Host: React.FC<IHost> = ({
  children,
  theme = RobotenTheme,
  mergeWith = 'Roboten',
}) => {
  const muiTheme = useMemo(() => {
    return mergeWith === 'Roboten'
      ? createRobotenTheme(theme)
      : createTheme(theme)
  }, [theme, mergeWith])

  return (
    <HelmetProvider>
      <Helmet>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />
      </Helmet>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>
      </StyledEngineProvider>
    </HelmetProvider>
  )
}
